import { render, staticRenderFns } from "./DocumentViewer.vue?vue&type=template&id=0eaf76f6&scoped=true&"
import script from "./DocumentViewer.vue?vue&type=script&lang=js&"
export * from "./DocumentViewer.vue?vue&type=script&lang=js&"
import style0 from "./DocumentViewer.vue?vue&type=style&index=0&id=0eaf76f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaf76f6",
  null
  
)

export default component.exports